import styled from '@emotion/styled';
import { Box } from '@mui/material';

import UserContents from '@/contents/User/UserContents';
import UserImage from '@/contents/User/UserImage';
import type { PublicUser } from '@/types/domain';

const Content = styled(Box)`
  position: relative;
  margin-top: 57px;
  z-index: 1;
`;

const MainVisual = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vw;
  max-height: 428px;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 55%, #333333bd 100%);
`;

export const CamperTop = ({ user }: { user: PublicUser }) => {
  if (!user) return <></>;

  return (
    <>
      <Content>
        <MainVisual>
          <UserImage user={user} />
        </MainVisual>
        <Box padding={3}>
          <UserContents user={user} />
        </Box>
      </Content>
    </>
  );
};
